import { ChangeDetectionStrategy, Component, OnInit, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AuthService } from 'src/app/shared/services';
import { DashboardSidebarComponent } from '../dashboard-sidebar/dashboard-sidebar.component';
import { DashboardTopbarComponent } from '../dashboard-topbar/dashboard-topbar.component';
import { CommonModule } from '@angular/common';
import { PushNotificationService } from 'src/app/modules/dashboard/services';
import { Toast, ToastModule } from 'primeng/toast';
import { AvatarModule } from 'primeng/avatar';

@Component({
    imports: [
        RouterModule,
        CommonModule,
        DashboardSidebarComponent,
        DashboardTopbarComponent,
        ToastModule,
        AvatarModule
    ],
    selector: 'app-dashboard.layout',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './dashboard.layout.component.html',
    styleUrls: ['./dashboard.layout.component.scss']
})
export class DashboardLayoutComponent implements OnInit{

  private authService = inject( AuthService );
  private pushNotService = inject(PushNotificationService);

  public user = computed(() => this.authService.currentUser() );

  async ngOnInit(): Promise<void> {
    if (this.user()?.role === 'admin') {
      this.actions = [
        {
          icon: 'ri-scales-line',
          routerLink: ['./operations/new/from_sketch'],
          tooltipOptions: {
            tooltipLabel: 'Nueva operación'
        },
        },
        {
          icon: 'ri-folder-user-line',
          routerLink: ['./employees/new-employee'],
          tooltipOptions: {
            tooltipLabel: 'Añadir empleado'
        },
        },
        {
          icon: 'ri-alarm-warning-fill',
          routerLink: ['./opportunities'],
          tooltipOptions: {
            tooltipLabel: 'Gestionar oportunidades'
        },
        },
      ]
    } else {
      this.actions = [
        {
          icon: 'ri-scales-line',
          routerLink: ['./operations/new/from_sketch']
        },
      ]
    }
      await this.requestNotificationPermission();
      this.pushNotService.listenToNotifications();
  }

  public actions: MenuItem[] | null;

  async requestNotificationPermission() {
  const permission = await Notification.requestPermission();
  if (permission === 'granted') {
    console.log('[FCM] Permiso concedido');
  } else {
    console.warn('[FCM] Permiso denegado');
  }
}



}